import type { MessageInstance } from 'antd/es/message/interface';
import type {
  ArgsProps as NotificationArgs,
  NotificationInstance,
} from 'antd/es/notification/interface';

type PendingTask = () => void;

let messageApi: MessageInstance | null = null;
let notificationApi: NotificationInstance | null = null;
const pendingTasks: PendingTask[] = [];

const runOrQueue = (task: PendingTask) => {
  if (messageApi || notificationApi) {
    task();
    return;
  }
  pendingTasks.push(task);
};

const flushPendingTasks = () => {
  if (!messageApi && !notificationApi) {
    return;
  }
  while (pendingTasks.length > 0) {
    const task = pendingTasks.shift();
    task?.();
  }
};

export const bindAntdAppApis = (
  message: MessageInstance,
  notification: NotificationInstance,
) => {
  messageApi = message;
  notificationApi = notification;
  flushPendingTasks();
};

export const appMessage = {
  success: (content?: string) => {
    runOrQueue(() => {
      void messageApi?.success(content || '');
    });
  },
  info: (content?: string) => {
    runOrQueue(() => {
      void messageApi?.info(content || '');
    });
  },
  warning: (content?: string) => {
    runOrQueue(() => {
      void messageApi?.warning(content || '');
    });
  },
  error: (content?: string) => {
    runOrQueue(() => {
      void messageApi?.error(content || '');
    });
  },
};

export const appNotification = {
  open: (config: NotificationArgs) => {
    runOrQueue(() => {
      void notificationApi?.open(config);
    });
  },
};
